import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { PopupLightboxComponent } from './popup-lightbox/popup-lightbox.component';
import { Item } from '../item-detail.service';
import { APPHOST } from '../../../app.component';

@Component({
  selector: 'app-image-carousel',
  standalone: true,
  imports: [CommonModule, DialogModule, PopupLightboxComponent],
  templateUrl: './image-carousel.component.html',
  styleUrl: './image-carousel.component.scss'
})
export class ImageCarouselComponent implements OnInit {
  @Input()
  product?: Item;

  @Input()
  images = new Set<string>();

  @Input()
  isSS=false

  constructor(public dialog: Dialog) {


  }

  reArrImages(s: string) {

    const d = new Set<string>()
    d.add(s)
    Array.from(this.images).forEach(w => {
      d.add(w)
    })
    this.images = d;
  }
  ngOnInit(): void {

  }
  gImg(num: number) {
    return   [...this.images][num]
  }
  open() {

    this.dialog.open(PopupLightboxComponent, {
      // width: '100vw',
      minHeight: '100%',
      height: '100vh',
      // minHeight: '100%',
      data: {
        product: this.product,
        images: this.images
      },
      hasBackdrop: true,
      disableClose: false

    });
  }
  getHost():string{
    return APPHOST;
  }
}
